import type { DocumentRepository } from '@zetyar/data-contracts'
import { createSupabaseDocumentRepository } from '@zetyar/supabase-client'
import { getSupabaseClient } from '@/infrastructure/supabase/app'

export const webDocumentRepository: DocumentRepository = createSupabaseDocumentRepository(getSupabaseClient())
